import { VueFormatterServiceCreatorV1 } from "./v1/vue-formatter-feature-service";
const defaultOptions = {};
function defineVueFormatterService(options = defaultOptions) {
    const opts = Object.assign(defaultOptions, options);
    const v1 = VueFormatterServiceCreatorV1(opts);
    return {
        create: (env) => {
            return {
                "1.0.0": (consumerId) => v1.create(consumerId, env),
            };
        },
        dependencies: {},
        id: "dbad:audi-vue-formatter-service",
    };
}
export * from "./types";
export { defineVueFormatterService };
//# sourceMappingURL=feature-service.js.map